// Fixed-size, time-limited buffer. Oldest entries fall off when either limit is hit.

export class RingBuffer {
  /**
   * @param {{ maxEntries?: number, maxAgeMs?: number }} [options]
   */
  constructor({ maxEntries = 500, maxAgeMs = 10 * 60 * 1000 } = {}) {
    this.maxEntries = maxEntries;
    this.maxAgeMs = maxAgeMs;
    /** @type {Array<{ t: number }>} */
    this.items = [];
    this.dropped = 0;
  }

  push(item) {
    this.items.push(item);
    const over = this.items.length - this.maxEntries;
    if (over > 0) {
      this.items.splice(0, over);
      this.dropped += over;
    }
  }

  prune(now = Date.now()) {
    const cutoff = now - this.maxAgeMs;
    let i = 0;
    while (i < this.items.length && this.items[i].t < cutoff) i++;
    if (i > 0) {
      this.items.splice(0, i);
      this.dropped += i;
    }
  }

  /** Adds older items (for example from the previous page) in front of the current ones. */
  prepend(items) {
    if (!items || !items.length) return;
    this.items = items.concat(this.items).sort((a, b) => a.t - b.t);
    const over = this.items.length - this.maxEntries;
    if (over > 0) this.items.splice(0, over);
    this.prune();
  }

  toArray(now = Date.now()) {
    this.prune(now);
    return this.items.slice();
  }

  clear() {
    this.items = [];
  }

  get size() {
    return this.items.length;
  }
}
